import Alert from 'core/alert';
import { BUTTON_FONT } from 'components/landing/constants';
import ButtonContainer from 'core/button-container';
import { PinkButton } from 'core/buttons/buttons';
import { postComment } from 'api/api';
import PropTypes from 'prop-types';
import styles from 'styles/AddComment.module.scss';
import TextArea from 'core/text-area';
import TextInput from 'core/text-input';
import { useState } from 'react';
import { useTranslations } from 'next-intl';

const AddComment = ({ pageCode, isRemote, onAddComment }) => {
    const t = useTranslations('comments.form');
    const [name, setName] = useState('');
    const [comment, setComment] = useState('');
    const [error, setError] = useState('');
    const [formVisible, setFormVisible] = useState(true);

    const handleClick = () => {
        const payload = {
            object_code: pageCode,
            object_name: isRemote ? 'page_remote' : 'page_page',
            name,
            comment
        };

        postComment(payload)
            .then(() => {
                onAddComment({
                    name,
                    comment,
                    datetime: 0,
                    created_at: new Date().toISOString()
                });
                setComment('');
                setName('');
                setFormVisible(false);
            })
            .catch(() => {
                setError(t('error'));
            });
    };

    return (
        <div className={styles.container}>
            {error && <Alert alertType="error" content={error} />}
            {!error && formVisible && (
                <>
                    <TextInput
                        fieldName="name"
                        placeholder={t('name')}
                        setValue={setName}
                        value={name}
                    />
                    <TextArea
                        fieldName="comment"
                        placeholder={t('comment')}
                        setValue={setComment}
                        value={comment}
                    />
                    <ButtonContainer align="right" width="auto">
                        <PinkButton
                            label={t('button')}
                            onClick={handleClick}
                            propsButton={BUTTON_FONT}
                            compact
                        />
                    </ButtonContainer>
                </>
            )}
        </div>
    );
};

AddComment.propTypes = {
    pageCode: PropTypes.string,
    isRemote: PropTypes.bool,
    onAddComment: PropTypes.func
};

export default AddComment;
